import type { FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { truncateText } from "@jti/fe-common";
import { useSelector } from "@jti/store/reduxHooks";
import { FormattedPrice, ProductMiniature, Tooltip } from "@jti/ui";

import styles from "./SummaryCartItems.module.scss";

export type SummaryBundleOptionValueProps = {
  prices: {
    initial_price: number;
    presentation_price?: number;
  };
  product_name: string;
  quantity: number;
  imageUrl?: string;
  tooltip_info?: string;
};

const SummaryBundleOptionValue: FC<SummaryBundleOptionValueProps> = ({
  product_name,
  quantity,
  prices: { initial_price, presentation_price = null },
  imageUrl,
  tooltip_info,
}) => {
  const { currency: shopCurrency } = useSelector((state) => state.cart);
  const { displayBundleSelectedItemsPrices } = useConfig();
  const maxTooltipLength = 130;

  return (
    <li className={styles.bundleOption} data-testid="summaryBundleOption">
      {imageUrl && <ProductMiniature imageUrl={imageUrl} showTitle={false} name={product_name} />}

      <div className={styles.bundleOptionHeader}>
        <div className={styles.bundleOptionCategory}>
          {quantity}&times; {product_name}
          {tooltip_info && (
            <div className={styles.tooltipIcon} data-testid="summaryBundleOptionTooltip">
              <Tooltip
                content={<span>{truncateText(tooltip_info, maxTooltipLength)}</span>}
                size="small"
                withCloseIcon
              />
            </div>
          )}
        </div>
      </div>

      {displayBundleSelectedItemsPrices && (
        <div className={styles.bundleOptionPrice} data-testid="summaryBundleOptionPrice">
          {presentation_price !== null && initial_price !== presentation_price ? (
            <>
              <FormattedPrice value={presentation_price} currency={shopCurrency.code} />

              <s className={styles.bundleOptionInitialPrice} data-testid="summaryBundleOptionInitialPrice">
                <FormattedPrice value={initial_price} currency={shopCurrency.code} />
              </s>
            </>
          ) : (
            <FormattedPrice value={initial_price} currency={shopCurrency.code} />
          )}
        </div>
      )}
    </li>
  );
};

export default SummaryBundleOptionValue;
